module.exports = __webpack_public_path__ + "img/logo.9ce9fe3f.png";